module.exports = __webpack_public_path__ + "img/街镇预警.9db578f4.png";